import { useTheme } from '@mui/material';
import { formatCNPJ, formatCPF, formatPhone } from 'app/helpers';
import { Heading4, Table, TextM } from 'app/components';
import {
  TableBodyCellContainer,
  TableHeadCellContainer,
} from 'app/styles/components/Table';
import { ReviewStepBorrowerBox, ReviewStepBox } from '../styles';
import { SubscriberName } from '../../SubscribersStep/SubscribersStep';
import { ParsedSubscriber } from '../utils/borrowerTypeParser';

type Subscriber = ParsedSubscriber;

interface ReviewStepSubscribersProps {
  tableHeader: string[];
  borrowerData: {
    full_name?: string;
    legal_name?: string;
    taxpayer_id?: string;
    phone?: {
      area_code?: string;
      number?: string;
    };
    email_address?: string;
  } | null;
  borrowerType: 'PERSON' | 'COMPANY';
  subscribers: Subscriber[] | null;
  isPerson: () => boolean;
}

const ReviewStepSubscribers = ({
  tableHeader,
  borrowerData,
  borrowerType,
  subscribers,
  isPerson,
}: ReviewStepSubscribersProps) => {
  const theme = useTheme();

  return (
    <ReviewStepBox marginTop="16px" marginBottom="16px">
      <Heading4
        style={{
          color: theme.palette.brand.secondary.base,
        }}
      >
        Assinantes
      </Heading4>
      <ReviewStepBorrowerBox>
        <Table
          tableHeadCell={tableHeader.map((header, index) => ({
            id: String(index),
            content: (
              <TableHeadCellContainer>
                <TextM weight="Bold">{header}</TextM>
              </TableHeadCellContainer>
            ),
          }))}
          tableBodyContent={[
            {
              id: '1',
              cells: [
                {
                  id: '1',
                  content: (
                    <TableBodyCellContainer>
                      <TextM weight="Bold">Tomador</TextM>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '2',
                  content: (
                    <TableBodyCellContainer>
                      <TextM weight="Regular">
                        {isPerson()
                          ? borrowerData?.full_name
                          : borrowerData?.legal_name}
                      </TextM>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '3',
                  content: (
                    <TableBodyCellContainer>
                      <TextM weight="Regular">
                        {borrowerType === 'PERSON'
                          ? formatCPF(borrowerData?.taxpayer_id || '')
                          : formatCNPJ(borrowerData?.taxpayer_id || '')}
                      </TextM>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '4',
                  content: (
                    <TableBodyCellContainer>
                      <TextM weight="Regular">
                        {formatPhone(
                          (borrowerData?.phone?.area_code || '') +
                            (borrowerData?.phone?.number || ''),
                        )}
                      </TextM>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '5',
                  content: (
                    <TableBodyCellContainer>
                      <TextM weight="Regular">
                        {borrowerData?.email_address}
                      </TextM>
                    </TableBodyCellContainer>
                  ),
                },
              ],
            },
          ].concat(
            subscribers?.map(
              ({ subscriber, subscriberType, subscriberPersonType }) => {
                return {
                  id: '1',
                  cells: [
                    {
                      id: '1',
                      content: (
                        <TableBodyCellContainer>
                          <TextM weight="Bold">
                            {SubscriberName[subscriberType]}
                          </TextM>
                        </TableBodyCellContainer>
                      ),
                    },
                    {
                      id: '2',
                      content: (
                        <TableBodyCellContainer>
                          <TextM weight="Regular">
                            {subscriber?.full_name}
                          </TextM>
                        </TableBodyCellContainer>
                      ),
                    },
                    {
                      id: '3',
                      content: (
                        <TableBodyCellContainer>
                          <TextM weight="Regular">
                            {subscriberPersonType === 'PERSON'
                              ? formatCPF(subscriber?.taxpayer_id || '')
                              : formatCNPJ(subscriber?.taxpayer_id || '')}
                          </TextM>
                        </TableBodyCellContainer>
                      ),
                    },
                    {
                      id: '4',
                      content: (
                        <TableBodyCellContainer>
                          <TextM weight="Regular">
                            {formatPhone(
                              (subscriber?.phone?.area_code || '') +
                                (subscriber?.phone?.number || ''),
                            )}
                          </TextM>
                        </TableBodyCellContainer>
                      ),
                    },
                    {
                      id: '5',
                      content: (
                        <TableBodyCellContainer>
                          <TextM weight="Regular">
                            {subscriber?.email_address}
                          </TextM>
                        </TableBodyCellContainer>
                      ),
                    },
                  ],
                };
              },
            ) || [],
          )}
        />
      </ReviewStepBorrowerBox>
    </ReviewStepBox>
  );
};

export default ReviewStepSubscribers;
